import config from '../config'

export const INVITE_STORAGE_KEY = 'INVITE_CODE'

/**
 * 从页面启动参数中读取邀请码
 * 来源：分享卡片路径 query（inviteCode）、小程序码 scene（URL 编码）
 */
export function readInviteFromOptions(options) {
	if (!options) {
		return ''
	}
	let code = ''
	if (options.query && options.query.inviteCode) {
		code = options.query.inviteCode
	}
	if (!code && (options.scene || (options.query && options.query.scene))) {
		const scene = options.scene || (options.query && options.query.scene)
		try {
			code = decodeURIComponent(scene)
		} catch (e) {
			code = scene
		}
	}
	return code || ''
}

/**
 * 记录邀请码到本地存储 + Vuex（App.vue 冷启动/热启动共用）
 */
export function recordInvite(options) {
	const code = readInviteFromOptions(options)
	if (code) {
		uni.setStorageSync(INVITE_STORAGE_KEY, code)
		commitInviteCode(code)
	}
}

/**
 * 登录/注册成功后清理邀请码，避免下次误绑定
 */
export function clearInviteCode() {
	uni.removeStorageSync(INVITE_STORAGE_KEY)
	commitInviteCode('')
}

function commitInviteCode(code) {
	try {
		// 延迟 require 避免循环依赖
		const store = require('../store').default
		if (store && store.commit) {
			store.commit('setInviteCode', code)
		}
	} catch (e) {
		console.warn('share: commit inviteCode fail', e)
	}
}

/**
 * 核心页公共分享 mixin
 * - onLoad 记录分享卡片/小程序码携带的邀请码
 * - onShow 按登录态设置原生"···"分享菜单（小程序 showShareMenu/hideShareMenu，H5 微信 JS-SDK）
 * 各核心页需自行定义 onShareAppMessage，用 shareAppMessageConfig 构造返回值
 */
const shareMixin = {
	data() {
		return {
			shareMpQrcode: '' // 个人小程序码（分享封面）
		}
	},
	onLoad(options) {
		this.recordInvite(options)
	},
	onShow() {
		this.setupNativeShare()
	},
	methods: {
		// 记录邀请码
		recordInvite(options) {
			recordInvite(options)
		},
		// 登录/注册成功后清理邀请码
		clearInviteCode() {
			clearInviteCode()
		},
		// 确保个人小程序码已生成（分享封面），复用后端 mp_qrcode 缓存
		ensureMpQrcode() {
			const that = this
			const userInfo = uni.getStorageSync('userInfo') || {}
			if (userInfo.mpQrcode) {
				that.shareMpQrcode = userInfo.mpQrcode
				return Promise.resolve(userInfo.mpQrcode)
			}
			// 并发去重：同一实例共享同一个进行中的请求
			if (that._mpQrcodePromise) {
				return that._mpQrcodePromise
			}
			that._mpQrcodePromise = new Promise((resolve) => {
				if (!userInfo.accessToken) {
					that._mpQrcodePromise = null
					resolve('')
					return
				}
				uni.request({
					url: config.baseUrl + '/member/qrcode',
					method: 'GET',
					header: {
						'Authorization': 'Bearer ' + userInfo.accessToken
					},
					success: (res) => {
						that._mpQrcodePromise = null
						if (res.statusCode === 200 && res.data && res.data.code === 200 && res.data.data) {
							that.shareMpQrcode = res.data.data
							userInfo.mpQrcode = res.data.data
							uni.setStorageSync('userInfo', userInfo)
							resolve(res.data.data)
						} else {
							resolve('')
						}
					},
					fail: () => {
						that._mpQrcodePromise = null
						resolve('')
					}
				})
			})
			return that._mpQrcodePromise
		},
		// 按登录态设置原生"···"分享：仅登录可转发（携带邀请码/个人二维码封面）
		setupNativeShare() {
			const userInfo = uni.getStorageSync('userInfo') || {}
			const isLogin = !!(userInfo && userInfo.accessToken && userInfo.id)
			if (isLogin) {
				// 登录时提前拉取个人小程序码，作为分享封面（后端有缓存，未生成才请求）
				this.ensureMpQrcode()
			}













			// 仅微信浏览器可用（main.js 中 boolForWeChatH5() 才挂载 $jwx）；
			// 普通浏览器（Chrome/Edge）调试时无 $jwx，静默跳过——微信分享菜单本就不存在
			if (isLogin && this.$jwx && typeof this.$jwx.configWeiXin === 'function') {
				const that = this
				that.ensureMpQrcode().then((qr) => {
					that.$jwx.configWeiXin((jweixin) => {
						const link = that.buildShareLink()
						if (jweixin.updateAppMessageShareData) {
							jweixin.updateAppMessageShareData({
								title: '东江惠购 康养平台',
								desc: '健康生活 · 轻松分享 · 智慧养生',
								link: link,
								imgUrl: qr
							})
						}
						if (jweixin.updateTimelineShareData) {
							jweixin.updateTimelineShareData({
								title: '东江惠购 康养平台',
								link: link,
								imgUrl: qr
							})
						}
					})
				})
			}

		},
		// H5 分享链接：当前 URL 去掉 hash/code/state 后追加 inviteCode（与签名 URL 无关，微信只校验签名 URL）
		buildShareLink() {

			if (typeof window !== 'undefined' && window.location) {
				const userInfo = uni.getStorageSync('userInfo') || {}
				try {
					const u = new URL(window.location.href)
					u.searchParams.delete('inviteCode')
					u.searchParams.delete('code')
					u.searchParams.delete('state')
					if (userInfo.memberNo) {
						u.searchParams.set('inviteCode', userInfo.memberNo)
					}
					u.hash = ''
					return u.href
				} catch (e) {
					return window.location.href.split('#')[0]
				}
			}

			return ''
		},
		/**
		 * 构造小程序 onShareAppMessage 返回值
		 * 登录时 path 追加 inviteCode、imageUrl 用个人小程序码；未登录返回默认配置（无推广）
		 */
		shareAppMessageConfig(extra = {}) {
			const userInfo = uni.getStorageSync('userInfo') || {}
			const isLogin = !!(userInfo && userInfo.accessToken && userInfo.id)
			let path = extra.path || '/pages/index/index'
			if (isLogin && userInfo.memberNo) {
				const sep = path.indexOf('?') > -1 ? '&' : '?'
				path += sep + 'inviteCode=' + userInfo.memberNo
			}
			const res = {
				title: extra.title || '东江惠购 康养平台',
				path: path
			}
			if (extra.imageUrl) {
				res.imageUrl = extra.imageUrl
			} else if (this.shareMpQrcode) {
				res.imageUrl = this.shareMpQrcode
			}
			return res
		}
	}
}

export default shareMixin
